import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TableModule} from 'primeng/table';
import {RouterModule} from '@angular/router';
import {DropdownModule} from 'primeng/dropdown';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CalendarModule} from 'primeng/calendar';
import {MultiSelectModule} from 'primeng/multiselect';
import {TooltipModule} from 'primeng/tooltip';
import {PanelModule} from 'primeng/panel';
import {CheckboxModule} from 'primeng/checkbox';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {TabViewModule} from 'primeng/tabview';
import {MessagesModule} from 'primeng/messages';
import {FileUploadModule} from 'primeng/fileupload';
import {InputTextModule} from 'primeng/inputtext';
import {SpinnerModule} from 'primeng/spinner';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {DynamicDialogModule} from 'primeng/dynamicdialog';
import {AppSharedModule} from '../appSharedModule/app-shared.module';
import {WorkVisitCrudComponent} from './components/work-visit/crud/work-visit-crud.component';
import {JiraCommentsComponent} from './components/work-visit/jira-comments/jira-comments.component';
import {NgxDaterangepickerMd} from 'ngx-daterangepicker-material';
import {NgxSpinnerModule} from 'ngx-spinner';
import {AssignmentListComponent} from './components/assignment/assignment-list/assignment-list.component';
import {AssignmentDetailsComponent} from './components/assignment/assignment-details/assignment-details.component';

@NgModule({
  declarations: [
    AssignmentListComponent,
    AssignmentDetailsComponent,
    WorkVisitCrudComponent,
    JiraCommentsComponent
  ],
  imports: [
    CommonModule,
    TableModule,
    RouterModule,
    DropdownModule,
    FormsModule,
    ReactiveFormsModule,
    CalendarModule,
    MultiSelectModule,
    TooltipModule,
    DynamicDialogModule,
    PanelModule,
    CheckboxModule,
    AppSharedModule,
    ConfirmDialogModule,
    TabViewModule,
    MessagesModule,
    FileUploadModule,
    InputTextModule,
    NgxDaterangepickerMd,
    NgxSpinnerModule,
    SpinnerModule,
    ProgressSpinnerModule,
  ],
  providers: []
})
export class HostingManagerModule {
}
